var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2271 1989",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2098.22,201.131c120.798,113.735 187.339,277.283 169.29,494.703c-47.498,572.183 -301.906,915.964 -575.396,1139.28c-409.992,334.78 -1788.21,160.413 -1686.8,-925.424c59.923,-641.57 564.659,-751.734 1141,-873.375c175.903,-37.126 350.52,-46.25 507.774,-25.241c18.233,453.991 -239.875,1233.62 -442.355,1263.32c-222.739,32.67 -249.515,-326.637 -409.014,-316.684c-152.281,9.502 -91.458,366.165 -235.829,364.749c-140.839,-1.381 -197.283,-579.443 -345.609,-576.206c-132.579,2.893 236.77,1002.28 383.142,989.445c170.957,-14.988 103.082,-345.072 223.869,-365.576c120.787,-20.505 187.322,402.743 469.303,393.839c333.835,-10.54 773.109,-1148.97 800.625,-1562.83Z",
    style: {
      fill: "#ff9aac"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.f1256b8a95e04d6075e3ce9c4df622a0.svg";
export { ForwardRef as ReactComponent };